export const getRowsByPage = (data, limit, current) => {
  const start = (current - 1) * limit;
  const end = start + limit;
  return data?.slice(start, end);
};
